import { NgModule } from '@angular/core';
import { UaePassComponent } from './components/uae-pass/uae-pass.component';

@NgModule({
  declarations: [UaePassComponent],
  imports: [],
  exports: [UaePassComponent],
})
export class UaePassModule {}